//REDUX
import { postData, deleteData } from '@redux/slices/functionals/request/requestActions';

import { CLocationRule, ELocationRuleStatus, INewLocationRule } from '@ts/ui-models';

//#region LocationRules

export const postLocationRule = (dispatch, locationRule: CLocationRule) => {
  if (locationRule.status === 'delete') {
    return dispatch(
      deleteData({
        url: `/api/v2/locationRule/${locationRule.getID()}`,
      })
    );
  }
  if (locationRule.status === ELocationRuleStatus.UPDATED || locationRule.status === ELocationRuleStatus.NEW) {
    {
      const newLoc: INewLocationRule = {
        locationTypeId: locationRule.locationTypeId,
        locationId: locationRule.locationId,
        name: locationRule.itemType?.name || locationRule.itemTypeId || '',
        itemTypeId: locationRule.itemTypeId,
        expectedValue: locationRule.expectedValue,
        aboveVariance: locationRule.aboveVariance,
        belowVariance: locationRule.belowVariance,
      };

      return dispatch(
        postData({
          url: '/api/v2/locationRule/new',
          dataBody: { ...newLoc },
        })
      );
    }
  }
};
//#endregion
